import { render, staticRenderFns } from "./BasicServiceManage.vue?vue&type=template&id=63bf0a32&scoped=true"
import script from "./BasicServiceManage.vue?vue&type=script&lang=js"
export * from "./BasicServiceManage.vue?vue&type=script&lang=js"
import style0 from "./BasicServiceManage.vue?vue&type=style&index=0&id=63bf0a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf0a32",
  null
  
)

export default component.exports